import React, { useMemo } from 'react';
import Page from 'src/components/Page';
import { Box, Container } from '@material-ui/core';
import PropTypes from 'prop-types';
import * as breadcrumbs from 'src/utils/breakcrumbs';
import { useParams } from 'react-router-dom';
import UserForm from './form/UserForm';

const UserFormView = ({ title }) => {
  const { id } = useParams();
  const pageBreadcrumbs = useMemo(
    () =>
      breadcrumbs.buildWithDashboard([
        {
          link: '/app/users/views',
          label: 'User',
        },
        {
          label: ` view  book`,
        },
      ]),
    []
  );

  return (
    <Page title={title} breadcrumbs={pageBreadcrumbs}>
      <Container maxWidth="lg">
        <Box>
          <UserForm editId={id} />
        </Box>
      </Container>
    </Page>
  );
};

UserFormView.propTypes = {
  title: PropTypes.string.isRequired,
};

export default UserFormView;
